// extracted by mini-css-extract-plugin
export default {"btn":"styles_btn__GNiHB","active":"styles_active__fjsUj","disabled":"styles_disabled__rg2yg"};